import React, { useCallback, useState } from 'react';

import { useSelector } from 'react-redux';

import { eventBus } from '@atc/cai-event-bus';

import {
    Button,
    Collapsible,
    ExpandTrigger,
    Heading,
    Panel,
} from 'reaxl';
import { sendClick } from 'reaxl-analytics';
import { psxMakeOfferClick, psxVDPTestDriveClick } from 'reaxl-analytics-handlers';

import vdpResultsDuck from '@/ducks/vdp/vdpResultsDuck.js';

import ConfidenceTile from '@/components/vehicledetails/ConfidenceTile';

import PsxMediaGalleryModalContainer from './PsxMediaGalleryModalContainer';

export function PsxPrimerContainer({
    inventoryId,
}) {

    const handleMakeOffer = (event) => {
        sendClick(psxMakeOfferClick, event, { inventoryId });
        eventBus.emit('psx.listingActions.openMakeOffer', {});
    };

    const handleScheduleTestDrive = (event) => {
        eventBus.emit('psx.listingActions.openTestDrive', {});

        sendClick(psxVDPTestDriveClick, event, { inventoryId });
    };

    const isWebComponentReady = useSelector(vdpResultsDuck.selectors.getIsWebComponentReady);

    const [showMoreContent, setShowMoreContent] = useState(true);

    const handleCollapsibleHeaderToggle = useCallback(() => {
        setShowMoreContent((prevState) => !prevState);
    }, []);

    return (
        <Panel data-cmp="buyOnlinePanel">
            <Panel.Body>
                <Heading
                    size={600}
                    color="primary"
                    className="margin-bottom-2 margin-top-1"
                >
                    Safe, Secure, and Convenient.
                </Heading>

                <ConfidenceTile
                    glyph="certified"
                    header="Buy from Verified Sellers"
                    description="We verify our sellers by IP address, email, phone number and ID so you can chat and schedule test drives safely."
                />

                <Collapsible
                    initialCollapse
                    onToggle={handleCollapsibleHeaderToggle}
                    toggleFooter={<ExpandTrigger isCollapsed={showMoreContent} />}
                >
                    <span>
                        <ConfidenceTile
                            glyph="warranty"
                            header="Vehicle History Check"
                            description="We confirm the car&rsquo;s ownership and accident history so there are no surprises when you buy."
                        />
                        <ConfidenceTile
                            glyph="usd-circle"
                            header="Buy Completely Online"
                            description="Pay online with our world-class lenders, your own bank or with cash. We&rsquo;ll even help with the paperwork!"
                        />
                    </span>
                </Collapsible>
                {isWebComponentReady && (
                    <>
                        <Button
                            block
                            bsStyle="primary"
                            className="margin-top-3"
                            onClick={handleMakeOffer}
                        >
                            Make Offer
                        </Button>
                        <Button
                            block
                            bsStyle="secondary"
                            onClick={handleScheduleTestDrive}
                        >
                            Schedule Test Drive
                        </Button>
                    </>
                )}
                <PsxMediaGalleryModalContainer
                    videoId="psxHowItWorks"
                    uiContext="link"
                />
            </Panel.Body>
        </Panel>
    );
}

export default PsxPrimerContainer;
